import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Home from '../Home.vue'
import IframeService from '../services/iframe'

const routes = [
    { path: '/', component: Home, name: 'home' },
    {
        path: '/payment/success',
        name: 'payment-success',
        component: () => import('../views/PaymentSuccess.vue')
    },
    {
        path: '/payment/cancel',
        name: 'payment-cancel',
        component: () => import('../views/PaymentCancel.vue')
    },
]

const router = new VueRouter({
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.afterEach((to, from) => {
    // from.matched vide = navigation initiale : ne pas faire sauter la page hôte
    if (from.matched.length === 0) {
        return
    }
    IframeService.scrollParentToTop()
})

export default router
